var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.897 8.5l1.95-2.55a.741.741 0 00-.21-1.088.776.776 0 00-.402-.112H8.06c0-.199-.08-.39-.224-.53a.772.772 0 00-1.082 0 .743.743 0 00-.224.53V17.5h-.764a.772.772 0 00-.541.22.743.743 0 000 1.06c.143.141.338.22.54.22h3.06a.772.772 0 00.54-.22.743.743 0 000-1.06.772.772 0 00-.54-.22h-.765v-5.25h9.176a.776.776 0 00.402-.112.755.755 0 00.282-.303.737.737 0 00-.072-.785l-1.95-2.55zm-1.568.45l1.377 1.8H8.059v-4.5h7.647l-1.377 1.8a.74.74 0 000 .9z"
  })));
}

export default SvgFlag;